import { AncillariesUtilsService } from '../../../../shared/ib-web-ancillaries-utils';
import angular from 'angular';

const componentOptions = {
    bindings: {
        passengers: '=',
        passengerIndex: '='
    },
    controllerAs: 'scrollPassengerSpecialMealCtrl',
    templateUrl: ['$rootScope', function ($rootScope) {
        return $rootScope.routes.templates + 'ib-scroll-passenger-special-meal.html';
    }]
};


const componentInfo = {
    module: 'ib-bob-box-module',
    selector: 'ibScrollPassengerSpecialMeal',
    inject: ['$window', '$scope', 'AncillariesUtilsService'],
    required: []
};

export class ibScrollPassengerSpecialMeal implements ng.IController {
    public containerPassenger = angular.element('.ib-scroll-list__passenger-container');
    public passengerWrap;
    public newPosition;
    public posContainer;
    public numColumns;
    public controlBack;
    public currentPassenger;
    public passengers;
    public passengerIndex;
    public isBtnNext = false;
    public isBtnBack = false;
    constructor (
        private $window: ng.IWindowService,
        private $scope: angular.IScope,
        private AncillariesUtilsService: AncillariesUtilsService) {

        this.$scope.$on('nextPassengerScroll', this.nextPassengerScroll);
        this.$scope.$on('reloadInitialStatus', this.reload);
        this.$scope.$on('selectFirstPassenger', this.reload);
    }

    activate = (): void => {
        this.containerPassenger.css('left', '0px');
        this.newPosition = 0, this.posContainer = 0, this.numColumns = 3, this.controlBack = 0;
        this.currentPassenger = this.passengers[this.passengerIndex].id;
        if (this.passengers.length === 2) {
            this.isBtnNext = true;
            this.isBtnBack = true;
            this.numColumns = 2;
        } else if (this.passengers.length <= 1) {
            this.isBtnNext = true;
            this.numColumns = 1;
        }

        if (this.$window.innerWidth <= 767) {
            this.numColumns = 1;
        }
        this.controlArrows();
    };

    $onInit (): void {
        this.activate();
    }

    // angular.element($window).bind('resize', () => {
    //     activate();
    // });

    reload = (event: any, data: any): void => {
        if (this.passengerIndex < data.index) {
            this.passengerIndex = data.index;
            this.currentPassenger = this.passengers[this.passengerIndex].id;
            // if next button is active, launch scroll
            if (!this.isBtnNext) {
                this.nextPassengerScroll();
            }
        } else {
            this.passengerIndex = data.index;
            // go to init the scroll
            this.activate();
        }

    };

    /**
     * Click back button
     */
    back = (): void => {
        this.passengerWrap = angular.element('.ib-scroll-list__passenger-wrap');
        this.posContainer++;
        this.newPosition += this.passengerWrap.outerWidth();
        this.containerPassenger.animate({ left: this.newPosition + 'px' });
        this.controlArrows();
        if (this.AncillariesUtilsService.isTouchDevice()) {
            this.$scope.$emit('previousPassenger');
        }
    };

    /**
     * Click next button
     */
    next = (): void => {
        this.passengerWrap = angular.element('.ib-scroll-list__passenger-wrap');
        this.posContainer--;
        this.newPosition -= this.passengerWrap.outerWidth();
        this.containerPassenger.animate({ left: this.newPosition + 'px' });
        this.controlArrows();
        if (this.AncillariesUtilsService.isTouchDevice()) {
            this.$scope.$emit('nextPassenger');
        }
    };

    /**
     * Change position of scroll to next passenger
     */
    nextPassengerScroll = (): void => {
        if ((this.AncillariesUtilsService.isResolutionToMobile() && this.AncillariesUtilsService.isTouchDevice() && this.passengers.length >= 2) || this.passengers.length > 2) {
            this.passengerWrap = angular.element('.ib-scroll-list__passenger-wrap');
            this.posContainer--;
            this.newPosition -= this.passengerWrap.outerWidth();
            this.containerPassenger.animate({ left: this.newPosition + 'px' });
            this.controlArrows();
        }
    };


    // Check the visibility of arrows
    controlArrows = (): void => {
        this.controlBack = (this.posContainer + this.passengers.length) - this.numColumns;
        this.controlBack === 0 ? this.isBtnNext = true : this.isBtnNext = false;
        this.posContainer === 0 ? this.isBtnBack = true : this.isBtnBack = false;
    };

    /**
     * Emits event to change passenger
     * @param {*} idPassenger
     */
    changePassenger = (idPassenger: any): void => {
        let i = 0;
        this.currentPassenger = idPassenger;
        // update the passengerIndex
        for (i = 0; i < this.passengers.length; i++) {
            if (this.passengers[i].id === idPassenger) {
                this.passengerIndex = i;
            }
        }
        this.$scope.$emit('selectScrollPassenger', idPassenger);
    };

    selectFirstPassenger = (): void => {
        this.passengerIndex = 0;
        this.containerPassenger.css('left', '0px');
        this.newPosition = 0, this.posContainer = 0, this.numColumns = 3, this.controlBack = 0;
        this.currentPassenger = this.passengers[this.passengerIndex].id;
        if (this.passengers.length === 2) {
            this.isBtnNext = true;
            this.isBtnBack = true;
            this.numColumns = 2;
        } else if (this.passengers.length <= 1) {
            this.isBtnNext = true;
            this.numColumns = 1;
        }

        if (this.$window.innerWidth <= 767) {
            this.numColumns = 1;
        }
        this.controlArrows();
    };
}



try {
    const mod = angular.module(componentInfo.module);
    ibScrollPassengerSpecialMeal.$inject = componentInfo.inject;
    mod.component(
        componentInfo.selector,
        angular.extend(componentOptions, { controller: ibScrollPassengerSpecialMeal })
    );
} catch (error) {
    const mod = angular.module(componentInfo.module, componentInfo.required);
    ibScrollPassengerSpecialMeal.$inject = componentInfo.inject;
    mod.component(
        componentInfo.selector,
        angular.extend(componentOptions, { controller: ibScrollPassengerSpecialMeal })
    );
}